<template>
  <div class="flex justify-around h-full">
    <div class="w-11/12 lg:w-5/6 flex flex-col gap-6">
      <div class="w-full flex flex-col md:flex-row gap-6">
        <div class="w-full md:w-1/3 flex flex-row md:flex-col gap-6">
          <automation-rate-number-chart :is-loading="loaders.automationRate || loaders.requestTotal"/>
          <answered-by-bot-number-chart :is-loading="loaders.automationRate || loaders.requestTotal"
                                        :request-total="automationRateTotal"
          />
        </div>

        <automation-rate-pie-chart :is-loading="loaders.automationRate || loaders.requestTotal"
                                   :request-total="automationRateTotal"
                                   class="w-full md:w-2/3"
        />
      </div>

      <user-feedback-pie-chart :is-loading="loaders.userFeedback" :feedback="userFeedback"/>

      <intent-usages :is-loading="loaders.intentUsages"
                     :bot-id="botId"
      />

      <assistance-resolution-chart :loaders="loaders"
                                   :bot-id="botId"
                                   @load-assistance-resolution="$emit('load-assistance-resolution', $event)"
      />
    </div>
  </div>
</template>

<script>
import AutomationRateNumberChart from '@/components/analytics/charts/AutomationRateNumberChart'
import AutomationRatePieChart from '@/components/analytics/charts/AutomationRatePieChart'
import AssistanceTypePieChart from '@/components/analytics/charts/AssistanceTypePieChart'
import AnsweredByBotNumberChart from '@/components/analytics/charts/AnsweredByBotNumberChart'
import IntentUsages from '@/components/analytics/IntentUsages'
import AssistanceResolutionChart from '@/components/analytics/charts/AssistanceResolutionChart'
import UserFeedbackPieChart from '@/components/analytics/charts/UserFeedbackPieChart'
import analyticsModule from '@/store/modules/analytics.module'

export default {
  name: 'AnalyticsCharts',

  components: {
    AssistanceTypePieChart,
    AnsweredByBotNumberChart,
    AutomationRatePieChart,
    AutomationRateNumberChart,
    IntentUsages,
    AssistanceResolutionChart,
    UserFeedbackPieChart
  },

  props: {
    loaders: {
      type: Object,
      required: true
    },
    botId: {
      type: String,
      required: true
    },
    userFeedback: {
      type: Object,
      default: null
    }
  },

  computed: {
    aggregatedAutomationOutcomes: analyticsModule.getAggregatedAutomationOutcomes,

    automationRateTotal() {
      return this.aggregatedAutomationOutcomes.reduce((total, { count }) => total + count, 0)
    }
  }
}
</script>
